import { t } from "@/i18n-js/instance";

import type { PostsOrder } from "./PostsTable/types";

export const RESULTS_PER_PAGE = 20;
export const ALL_STATUS = "all";
export const DRAFT_STATUS = "draft";
export const SCHEDULED_STATUS = "scheduled";
export const PUBLISHED_STATUS = "published";

export const DEFAULT_ORDER: PostsOrder = { updated_at: "desc" };
export const SCHEDULED_DEFAULT_ORDER: PostsOrder = { published_at: "asc" };

const LOCALE_NAMESPACE = "settings.posts";

export const TABS = Object.freeze({
  get [ALL_STATUS]() {
    return t([LOCALE_NAMESPACE, "tabs", "all"]);
  },
  get [DRAFT_STATUS]() {
    return t([LOCALE_NAMESPACE, "tabs", "drafts"]);
  },
  get [SCHEDULED_STATUS]() {
    return t([LOCALE_NAMESPACE, "tabs", "scheduled"]);
  },
});
